import React, { useEffect } from "react";
import { Button, Card, Layout, PageHeader, Tag } from "antd";
import { InterestDlg } from "./InterestDlg";
import { useInterests } from "../../../hooks/settings/useInterests";

export const Interests = () => {
  const { groups, refresh, saving, save, check, openEditDlg, setOpenEditDlg } = useInterests();
  useEffect(() => {
    refresh();
  }, []);
  return (
    <Layout.Content>
      <PageHeader
        title="Interest List"
        extra={[
          <Button key="add" type="primary" onClick={() => setOpenEditDlg(true)}>
            Add Interest
          </Button>,
        ]}
      ></PageHeader>
      <div className="p-24px">
        {groups.map((g) => (
          <Card title={g.groupName} key={g.groupName} style={{ marginBottom: 16 }} size="small">
            {g.children.map((c) => (
              <Tag key={c.name}>{c.name}</Tag>
            ))}
          </Card>
        ))}
      </div>
      <InterestDlg open={openEditDlg} save={save} saving={saving} check={check} close={() => setOpenEditDlg(false)} />
    </Layout.Content>
  );
};
